import WebApp from '@twa-dev/sdk';
import { nanoid } from 'nanoid';

import { getLocale } from '@/app/lib/localization/helpers/get-locale';
import { translationImportByLanguage } from '@/app/lib/localization/helpers/translation-import-by-language';

import { GameOrientation } from '@/shared/api/game/types';
import { getDecodedStartappQuery } from '@/shared/helpers/telegram/get-decoded-startapp-query';
import { resolvePdTma } from '@/shared/helpers/telegram/resolve-pd-tma';

import { type InitialState, type ThemeMode } from '../types';
import { parseJWTToken } from './parse-jwt-token';

export const getInitialAppState = async (token: string): Promise<InitialState> => {
  const theme = WebApp.colorScheme as ThemeMode;
  const startAppArgs = getDecodedStartappQuery();
  const lang = await getLocale(startAppArgs);
  const messages = (await translationImportByLanguage[lang.app]()).default;

  const state: InitialState = {
    sessionId: nanoid(),
    token,
    decodedToken: parseJWTToken(token),
    gameUrl: null,
    startAppArgs,
    theme,
    userProfile: undefined,
    showDevMenu: false,
    lang,
    wsSentInitialMsg: false,
    messages,
    isWebMode: false,
    isLiteMode: false,
    screenOrientation: GameOrientation.PORTRAIT,
    isExclusiveMode: false,
    pdTma: resolvePdTma(),
  };

  return state;
};
